import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import { TFunction } from 'i18next';
import React from 'react';

import { WarningModalType } from 'components/TravellerInformationForm/hooks/useReservation';

type GetAirlineModal = {
  t: TFunction;
};

export function getAirlineModal({ t }: GetAirlineModal): WarningModalType {
  return {
    children: (
      <ElementsSDK.Typography
        variant="p1"
        dangerouslySetInnerHTML={{
          __html: t('tip.loungeForm.airlineGroup.modal.text'),
        }}
      />
    ),
  };
}
